import React from 'react';

import { STEP_VIEWS } from '../constants';
import { WizardComponent } from '../../shared/wizard';

export const CheckListsWizardComponent = () => (
  <WizardComponent total={2} stepViews={STEP_VIEWS} />
);
